import {getWallet} from '../../helpers/wallet';
import {decrypt} from '../../helpers/crypto';
import {addPending} from './addPending';
import Neon, { wallet as NeonWallet, api as NeonAPI} from "@cityofzion/neon-js";
import axios from 'axios';
import {SET_LOADING} from '../../types';

export function payNEO({password,amount,to},done){
	return function(dispatch,getState) {
    try {
			dispatch({type:SET_LOADING,payload:true})

			let {privateKey,address} = getWallet(getState,'neo',password)
			console.log({address,privateKey})
			const intent = NeonAPI.makeIntent({NEO:amount},to)
	    const apiProvider = new NeonAPI.neoscan.instance('MainNet');
	    const config = {
	      api: apiProvider, // The API Provider that we rely on for balance and rpc information
	      account: privateKey, // The sending Account
	      intents: intent // Our sending intents
	    };
	    Neon.sendAsset(config).then(config => {
	      addPending(dispatch,getState(),{hash:config.tx.hash,chain:'NEO',to,from:address,amount})
				dispatch({type:SET_LOADING,payload:false})
				done(null,config.tx.hash)
	    })
	    .catch(config => {
	      console.log(config);
				dispatch({type:SET_LOADING,payload:false})
	      done(config)
	    });
    }
    catch(err){
			dispatch({type:SET_LOADING,payload:false})
      done(err);
    }
	}
}


async function neoSign(dispatch,getState,{password,amount,to},done) {
  let privateKey = '';
  try {
    privateKey = decrypt(getState().passport.wallet.neo.privateKey, password, getState().passport.wallet.neo.salt, getState().passport.wallet.neo.iv);
    let account = new NeonWallet.Account(privateKey).privateKey;

    let address = account.address;
    privateKey = account.privateKey;

  }
  catch(err){
    done(err,null);
    return;
  }
  let response = await axios.get(`https://api.neoscan.io/api/main_net/v1/get_balance/${getState().passport.wallet.neo.address}`)
  let tx = Neon.create.contractTx();

  try {
    tx.addIntent("NEO", amount, to)
      .calculate(response.data.balance) // Now we add in the balance we retrieve from an external API and calculate the required inputs.
      .sign(privateKey); // Sign with the private key of the balance

    const hash = tx.hash;
    const serializedTx = tx.serialize();

    done(null,tx);
  }
  catch(err){
    done(err)
  }
}

export function signNEO({password,amount,to},done){
	return async function(dispatch,getState) {
    neoSign(dispatch,getState,{password,amount,to},(err,signed)=>{
      done(err,signed);
    })
	}
}
